/******
 * This file was generated by a Rake task.
 * Do not modify this file manually.
 * Add changes to the `CustomScheduledReport.ts` file.
 ******/
// oxlint-disable-next-line no-unused-vars
import dayjs, { Dayjs } from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
dayjs.extend(timezone);

import { CustomScheduledReport } from "./CustomScheduledReport";

import { ProcurementFilter } from "./ProcurementFilter";
import { ProcurementView } from "./ProcurementView";
import { ScheduledReport } from "./ScheduledReport";

export abstract class CustomScheduledReportModel {
    id: number;
    createdAt: Dayjs;
    procurementFilterId: number | null;
    procurementViewId: number;
    scheduledReportId: number;
    updatedAt: Dayjs;
    procurementFilter: ProcurementFilter | null | undefined;
    procurementView: ProcurementView | null | undefined;
    scheduledReport: ScheduledReport | null | undefined;
    _destroy: boolean | undefined;

    /* eslint-disable max-statements */
    constructor(
        id: number,
        createdAt: Dayjs,
        procurementFilterId: number | null,
        procurementViewId: number,
        scheduledReportId: number,
        updatedAt: Dayjs,
        procurementFilter: ProcurementFilter | null | undefined,
        procurementView: ProcurementView | null | undefined,
        scheduledReport: ScheduledReport | null | undefined
    ) {
        this.id = id;
        this.createdAt = createdAt;
        this.procurementFilterId = procurementFilterId;
        this.procurementViewId = procurementViewId;
        this.scheduledReportId = scheduledReportId;
        this.updatedAt = updatedAt;
        this.procurementFilter = procurementFilter;
        this.procurementView = procurementView;
        this.scheduledReport = scheduledReport;
    }
    /* eslint-enable max-statements */

    // oxlint-disable-next-line complexity
    static fromApiObject(json: any, timezone: string): CustomScheduledReport {
        const newObject = new CustomScheduledReport(
            json["id"],
            dayjs(json["created_at"]).tz(timezone),
            json["procurement_filter_id"],
            json["procurement_view_id"],
            json["scheduled_report_id"],
            dayjs(json["updated_at"]).tz(timezone),
            json["procurement_filter"] == null
                ? json["procurement_filter"]
                : ProcurementFilter.fromApiObject(json["procurement_filter"], timezone),
            json["procurement_view"] == null
                ? json["procurement_view"]
                : ProcurementView.fromApiObject(json["procurement_view"], timezone),
            json["scheduled_report"] == null
                ? json["scheduled_report"]
                : ScheduledReport.fromApiObject(json["scheduled_report"], timezone)
        );

        return newObject;
    }

    // oxlint-disable-next-line complexity
    toApiObject(): any {
        return {
            id: this.id,
            created_at: this.createdAt,
            procurement_filter_id: this.procurementFilterId,
            procurement_view_id: this.procurementViewId,
            scheduled_report_id: this.scheduledReportId,
            updated_at: this.updatedAt,
            _destroy: this._destroy,
        };
    }

    // NOTE: This could potentially cause infinite loops if the object graph is
    // circular.
    inAlternateTimezone(timezone: string): CustomScheduledReport {
        const clone = Object.create(this) as CustomScheduledReport;

        for (const key of Object.keys(this)) {
            if (this[key] instanceof dayjs) {
                // @ts-expect-error: Typescript thinks that this is not a dayjs object even though it is checked on the line before
                clone[key] = this[key].tz(timezone);
            } else if (Array.isArray(this[key])) {
                clone[key] = this[key].map((item) =>
                    item.inAlternateTimezone ? item.inAlternateTimezone(timezone) : item
                );
            } else if (this[key] && this[key].inAlternateTimezone) {
                clone[key] = this[key].inAlternateTimezone(timezone);
            }
        }

        return clone;
    }
}
